import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { JackpotBarWrapper } from './JackpotBar.style';
import { JackpotForGameType } from 'src/domains/casino/state/AppCasino/casino-sockets/jackpot-socket/JackpotsDetailsModels';

interface PropsType {
    jackpotModel: JackpotForGameType;
    isBigTile: boolean;
}

export const JackpotBar = observer('JackpotBar', (props: PropsType) => {
    const { jackpotModel } = props;

    return <JackpotBarWrapper isBigTile={props.isBigTile}>{jackpotModel.amount}</JackpotBarWrapper>;
});
